import { PACKET_DATA_SIZE, Transaction, VersionedTransaction } from '@solana/web3.js';
import { COMMON_TX_ERRORS, TransactionError } from './errors';

export const checkTxSize = (transaction: VersionedTransaction | Transaction) => {
  let txLength = (() => {
    try {
      return transaction.serialize({
        requireAllSignatures: false,
      }).length;
    } catch (e) {
      return PACKET_DATA_SIZE + 1;
    }
  })();

  if (txLength > PACKET_DATA_SIZE) {
    return { error: new TransactionError(COMMON_TX_ERRORS.TRANSACTION_TOO_LARGE) };
  }
};
